module.exports = __webpack_public_path__ + "img/pic_banner_gongchang.aa2cfd96.png";